<script setup lang="ts">
import type {HTMLAttributes} from 'vue'
import {cn} from '@/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    :class="cn('grid grid-cols-[100px_auto_100px] px-4 md:px-6 gap-y-1.5 text-center font-bold text-base py-3 border-b-[0.5px] border-gray-400', props.class)"
  >
    <slot/>
  </div>
</template>
 